import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';

export function useIsAdmin(): boolean {
  const { token } = useAuth();
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    if (!token) { setAdmin(false); return; }
    api<{ admin: boolean }>('/concepts/approvals/me', { token }).then((m) => setAdmin(m.admin)).catch(() => setAdmin(false));
  }, [token]);

  return admin;
}
